import z from 'zod';
import { scopedEntity, string, datetime, alarmProfessionalResponderRef, alarmRef, customerRef, assetRef, staticResponderRef, } from '../common';
export var AlarmProfessionalResponderType;
(function (AlarmProfessionalResponderType) {
    AlarmProfessionalResponderType["Sequrix"] = "sequrix";
})(AlarmProfessionalResponderType || (AlarmProfessionalResponderType = {}));
export var AlarmProfessionalResponderStatus;
(function (AlarmProfessionalResponderStatus) {
    AlarmProfessionalResponderStatus["Invited"] = "invited";
    AlarmProfessionalResponderStatus["Accepted"] = "accepted";
    AlarmProfessionalResponderStatus["Rejected"] = "rejected";
    AlarmProfessionalResponderStatus["Started"] = "started";
    AlarmProfessionalResponderStatus["OnLocation"] = "onLocation";
    AlarmProfessionalResponderStatus["Finished"] = "finished";
    AlarmProfessionalResponderStatus["Error"] = "error";
    AlarmProfessionalResponderStatus["Canceled"] = "canceled";
})(AlarmProfessionalResponderStatus || (AlarmProfessionalResponderStatus = {}));
export const alarmProfessionalResponderStatistics = z.object({
    invitedAt: datetime,
    acceptedAt: datetime.nullable(),
    rejectedAt: datetime.nullable(),
    startedAt: datetime.nullable(),
    onLocationAt: datetime.nullable(),
    finishedAt: datetime.nullable(),
});
export const alarmProfessionalResponderPhoto = z.object({
    timestamp: datetime,
    url: string,
});
export const alarmProfessionalResponderMeta = z.object({
    photos: z.array(alarmProfessionalResponderPhoto).optional(),
    overridePhoneNumber: string.optional(),
});
export const alarmProfessionalResponder = z.object({
    ...scopedEntity.shape,
    type: z.nativeEnum(AlarmProfessionalResponderType),
    active: z.boolean(),
    status: z.nativeEnum(AlarmProfessionalResponderStatus),
    alarm: alarmRef,
    customer: customerRef,
    asset: assetRef,
    staticResponder: staticResponderRef,
    statistics: alarmProfessionalResponderStatistics,
    meta: alarmProfessionalResponderMeta,
    supersededBy: alarmProfessionalResponderRef.nullable(),
});
